export const getLoginResponse = () => {
  const raw =
    localStorage.getItem("loginResponse") ||
    sessionStorage.getItem("loginResponse");
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const getStoredUser = () => {
  const raw =
    localStorage.getItem("user") || sessionStorage.getItem("user");
  if (raw) {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  return getLoginResponse()?.data ?? null;
};

export const isAuthenticated = () => Boolean(getStoredUser());

const getUserRole = () => {
  const user = getStoredUser();
  return user?.role || user?.userRole || "";
};

export const isAdmin = () => getUserRole() === "admin";

export const isPartner = () => getUserRole() === "partner";

export const getDashboardHomePath = () =>
  isPartner() ? "/dashboard/esims" : "/dashboard";

export const logout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("loginResponse");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("loginResponse");
};
